import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Title } from '@siftscience/focus-components/text'
import { LIFECYCLE_STATUS_MAPPING } from './consts/lifecycle'

const useStyles = makeStyles(() => ({
  background: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: 6,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

interface TransitionWarningProps {
  oldState: string
  futureState: string
}

const TransitionWarning = ({
  oldState,
  futureState
}: TransitionWarningProps) => {
  const classes = useStyles()
  const stateBefore = LIFECYCLE_STATUS_MAPPING[oldState]?.title || oldState
  const stateAfter = LIFECYCLE_STATUS_MAPPING[futureState]?.title || futureState
  return (
    <div className={classes.background}>
      <Title size="medium">
        Sorry, Editing is unavailable because the dispute is transitioning from
        "{stateBefore}" to "{stateAfter}".
      </Title>
    </div>
  )
}

export default TransitionWarning
